import styled from "styled-components"

export const ContainerAtencionSinTurno = styled.div`
    width: 100vw;
    height: calc(100vh - 30vh);
    display: flex;
    align-items: center;
    gap: 30px;
    flex-direction: column; 
    overflow: scroll;
    position: absolute;
    bottom: 1vh;
`;